var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForensic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 346,
    viewBox: "0 0 325 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.489 238.158C118.202 246.648 117.052 264.45 138.743 267.736",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5164 234.05C73.8355 240.623 64.7979 252.783 64.7979 265.271C64.7979 280.882 82.8732 291.563 93.5541 293.206",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.597 70.5502C127.24 78.7663 127.404 97.1703 114.916 105.058C102.427 112.945 82.8732 108.344 74.6571 105.058",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.094 4C149.423 4 162.569 32.7563 162.569 48.3668V321.141C162.569 344.967 118.202 350.719 105.878 321.141C91.9108 331.822 43.4359 323.606 46.7224 290.741C19.6094 291.563 -14.0767 240.623 15.5012 197.078C-5.03898 174.894 3.17709 133.814 36.0414 118.204C18.7876 94.3769 31.1118 48.3668 73.8354 48.3668C73.8354 16.8171 98.4836 4 114.094 4Z",
    stroke: "black",
    strokeWidth: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.554 77.9446C85.064 72.7411 67.2626 66.4422 57.4032 76.3014C45.572 88.1324 52.4736 103.141 57.4032 109.166",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3757 164.214C102.866 160.653 124.447 148.767 142.851 129.706",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.846 149.425C124.775 156.545 131.019 176.045 116.559 197.078",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3982 207.759C30.564 212.141 24.0459 225.341 28.6469 243.088C34.3982 265.271 54.9383 264.45 63.976 261.163",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184 51.0012C211.896 51.0012 263.145 68.0012 268 113.001",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184 70.0012C222.333 72.0931 299 102.949 299 209.637C299 286.91 240.657 320.983 227.5 330.501",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184 90.0012C198.598 92.4774 231.236 101.144 245 116.001",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M183 10.0012C215.972 11.6534 269.639 25.7557 298 67.0012",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M183 30.0012C196.648 30.0012 226.467 35.8873 240 44.0012",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186 110.001C201.186 114.283 234.646 127.077 247 144.001",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M186 130.001C209.539 137.311 255.866 163.834 252.861 211.451C249.104 270.971 197.269 302.17 186 310.001",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M184 153.001C201.977 159.961 230 175.755 230 213.315C230 245.501 195.103 271.176 184 282.001",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.539 177.001C201.274 184.407 227.479 214.501 184 250.001",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M254 52.0012C273.839 64.9991 314.614 107.996 319 176.001",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M257.721 138.001C281.309 176.652 305.64 277.501 184 335.001",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M320.762 206.001C322.399 224.591 316.34 271.218 279 309.001",
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForensic);
export default __webpack_public_path__ + "static/media/forensic.8e9bb0c7fad73d5013baabd27a29f4dd.svg";
export { ForwardRef as ReactComponent };